import './bootstrap.js';
import store from './store.js';
import {createApp} from 'vue';
import Federation from "./components/Federation.vue";
import FederationDetails from "./components/FederationDetails.vue";
import NoticesDetails from "./components/NoticesDetails.vue";
import BranchLocator from "./components/BranchLocator.vue";
import FontsidevueNav from "./components/FontsidevueNav.vue";
import federationName from "./components/federationName.vue";
import GlanceunionFederation from "./components/GlanceunionFederation.vue";
import AdminFederation from "./components/backend/Federation.vue";
import ViewFederation from "./components/backend/ViewFederation.vue";
import CreateFederation from "./components/backend/CreateFederation.vue";
import Notices from "./components/backend/Notices.vue";
import CreateNotice from "./components/backend/CreateNotice.vue";
import Volunteers from "./components/backend/Volunteers.vue";
import CreateVolunteer from "./components/backend/CreateVolunteer.vue";
import VolunteersDetails from "./components/VolunteersDetails.vue";
import Reports from "./components/backend/Reports.vue";
import ReportDetails from "./components/ReportDetails.vue";
import CreateReport from "./components/backend/CreateReport.vue";
import CreateGallery from "./components/backend/CreateGallery.vue";
import ImageGallery from "./components/backend/ImageGallery.vue";
import CreateSlider from "./components/backend/CreateSlider.vue";
import ViewSlider from "./components/backend/ViewSlider.vue";
import CreateUser from "./components/backend/CreateUser.vue";
import ViewUser from "./components/backend/ViewUser.vue";
import EditUser from "./components/backend/EditUser.vue";
import RdrsMap from "./components/backend/RdrsMap.vue";
import EditSlider from "./components/backend/EditSlider.vue";
import LanguageSwitcher from "./components/LanguageSwitcher.vue";
const app=createApp({
   components:{
   	 Federation,
       FederationDetails,
       AdminFederation,
       ViewFederation,
       CreateFederation,
       Notices,
       CreateNotice,
       Volunteers,
       CreateVolunteer,
       NoticesDetails,
       VolunteersDetails,
       Reports,
       CreateReport,
       ReportDetails,
       CreateGallery,
       ImageGallery,
       CreateSlider,
       ViewSlider,
       CreateUser,
       ViewUser,
       EditUser,
       BranchLocator,
       FontsidevueNav,
       federationName,
       GlanceunionFederation,
       RdrsMap,
       EditSlider,
       LanguageSwitcher,
   
   }
});
app.use(store);
app.mount("#wrapper");
